import { render, staticRenderFns } from "./BuyerDropdownField.vue?vue&type=template&id=60d3668c"
import script from "./BuyerDropdownField.vue?vue&type=script&lang=ts"
export * from "./BuyerDropdownField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60d3668c')) {
      api.createRecord('60d3668c', component.options)
    } else {
      api.reload('60d3668c', component.options)
    }
    module.hot.accept("./BuyerDropdownField.vue?vue&type=template&id=60d3668c", function () {
      api.rerender('60d3668c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/BuyerDropdownField.vue"
export default component.exports